import { createFileRoute } from '@tanstack/react-router';

import { TrialExpiredPage } from '@/pages/trial-expired';

export const Route = createFileRoute('/trial-expired')({
    component: TrialExpiredPage,
});
